import { Component } from "@angular/core";

@Component({
    selector: "app-home-client-reviews",
    templateUrl: "./home-client-reviews.component.html",
    styleUrl: "./home-client-reviews.component.scss",
    standalone: false,
})
export class HomeClientReviewsComponent {
    reviews: { name: string; review: string; image: string; rating: number; date: string }[] = [
        {
            name: "N Chingkheinganba",
            review: "My daughter absolutely loves these blocks! The colors are so vibrant and she spends hours building different creations. Best purchase ever!",
            image: "../../../assets/images/image1.jpeg",
            rating: 5,
            date: "01/01/2023",
        },
        {
            name: "H Nganthoibi",
            review: "Quality is outstanding! Safe, durable, and my son has learned so much while playing. The sets are worth every penny.",
            image: "../../../assets/images/image2.jpg",
            rating: 5,
            date: "19/01/2024",
        },
        {
            name: "L Chanulembi",
            review: "Both my kids play together with these blocks. It's amazing to see their creativity and teamwork. Highly recommend!",
            image: "../../../assets/images/image3.jpg",
            rating: 5,
            date: "19/01/2021",
        },
    ];
}
